<template>
  <div class="login container">
    <div v-if="!sellCardPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <form v-else @submit.prevent="submit">

        <div class="d-flex justify-content-between">
        <div class="col-xs-6 pl-3 pt-5">
          <cta type="button" @click="navBack()" shape="circle" icon="left-arrow" text="" margin="no-margin" />
        </div>
        <div class="col-xs-6  pr-3 pt-5">
          <cta type="submit" shape="circle" text="" icon="right-arrow" :disabled="!paymentConfirm" margin="no-margin" :loading="submitted" />
        </div>
        </div>

        <div class="row">
         <h2 class="col-md-12 pt-2">Take payment of</h2>
        </div>

        <div class="row">
          <h1 v-if="orderPayload.customPriceModifier" class="col-md-12 pt-2">{{getPriceDisplayValue(currency.symbol, orderPayload.custom_price_modifier_value, 1, currency.denomination)}}</h1>
          <h1 v-else class="col-md-12 pt-2">{{getPriceModifierDisplayValue(orderPayload.price_modifier,1)}}</h1>
        </div>
        


      <div class="row">
          
            <cta type="button" class="col-12 pr-1 pl-1 pt-4 pb-4" :active="paymentConfirm" size="small" text="Confirm payment has been taken" @click="takePayment" />
          
      </div>



      <div class="row">

            <cta link="foc-reason" class="col-12 pr-1 pl-1 pt-5" size="small" text="Issue this card free of charge"/>
      
      </div>
      

    </form>
   
  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {
        submitted       : false,
        paymentConfirm  : false,
        totalPayment    : 0,
        currency        : null,
      };
  },
  created:function(){
    this.currency = this.accountCurrency;
  },
  computed: {

    orderPayload(){
      return this.$store.getters.getOrderPayload;
    },

    account(){
      return this.$store.getters.getAccount;
    },

    accountCurrency(){
      return this.$store.getters.getAccountCurrency;
    }

  },
  watch:{

    
    
  },
  mounted: function(){

  },
  methods:{

    takePayment() {
      this.paymentConfirm = true;
    },

    navBack() {
      if(this.orderPayload.digitalJourney) {
        this.$router.push({ name: 'digital-gift'});
      } else {
        this.$router.push({ name: 'sell'});
      }
    },

    submit() {

        this.$set(this.orderPayload, 'payment', 'normal');
        this.$store.commit("ORDER_PAYLOAD",this.orderPayload);

        if(this.orderPayload.digitalJourney) {
            this.$router.push({ name: 'receipt'});
        }

        if(this.orderPayload.physicalJourney) {
            if(this.account.auto_generate_card_references)
                this.$router.push({ name: 'receipt'});
            else
                this.$router.push({ name: 'gift-unique-code'});
        }
        
    }
    
  }
}
</script>

<style scoped>
  h1{
    transition: text-shadow 0.5s, transform 0.5s;
    text-shadow: 0 0 0 rgba(255,255,255,0.5);
    font-size: 4em;
    margin: 0;
  }

  .select-holder {
    margin-top: 15px;
  }

</style>
